module.exports = __webpack_public_path__ + "img/HR32247795989.6c67ba55.png";